module.exports = __webpack_public_path__ + "img/29.39bae8aa.gif";